import DataTable from "react-data-table-component"
import CustomDropdown from "../../../../../components/common/Dropdown/CustomDropDown"
import FilterInTable from "../../../../Manage/FilterInTable"
import SellerActionDropdown from "../../../../../components/common/SellerCommonComponents/SellerActionDropdown/SellerActionDropdown"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"

const Active = () => {

    const data = [
        { couponCode: 'COUPON10', couponType: 'Percentage off', validityPeriod: '30 March - 7 April', discount: '20%', conditions: ['Min.spent: 20$', '1 per customer'], applicability: "Electronics", used: ' 20 / 100', status: "Active" },
        { couponCode: 'COUPON10', couponType: 'Percentage off', validityPeriod: '30 March - 7 April', discount: '20%', conditions: ['Min.spent: 20$', '1 per customer'], applicability: "Electronics", used: ' 20 / 100', status: "Active" },
        { couponCode: 'COUPON10', couponType: 'Percentage off', validityPeriod: '30 March - 7 April', discount: '20%', conditions: ['Min.spent: 20$', '1 per customer'], applicability: "Electronics", used: ' 20 / 100', status: "Active" },
        { couponCode: 'COUPON10', couponType: 'Percentage off', validityPeriod: '30 March - 7 April', discount: '20%', conditions: ['Min.spent: 20$', '1 per customer'], applicability: "Electronics", used: ' 20 / 100', status: "Active" },
        { couponCode: 'COUPON10', couponType: 'Percentage off', validityPeriod: '30 March - 7 April', discount: '20%', conditions: ['Min.spent: 20$', '1 per customer'], applicability: "Electronics", used: ' 20 / 100', status: "Active" },
    ]

    const columns = [
        {
            name: 'Coupon Code',
            selector: row => row.couponCode,
            wrap: true
        },
        {
            name: 'Coupon type',
            selector: row => row.couponType,
            wrap: true
        },
        {
            name: 'Validity Period',
            selector: row => row.validityPeriod,
            wrap: true
        },
        {
            name: 'Discount',
            selector: row => row.discount,
            wrap: true
        },
        {
            name: 'Conditions',
            cell: row => <div>
                {row.conditions.map(item => <div>{item}</div>)}
            </div>,
            wrap: true
        },
        {
            name: 'Applicability',
            selector: row => row.applicability,
            wrap: true
        },
        {
            name: 'Used',
            selector: row => row.used,
            wrap: true
        },
        {
            name: 'Status',
            selector: row => {
                let color;
                switch (row.status) {
                    case 'Active':
                        color = '#41B8E4';
                        break;
                    case 'Deactivated':
                        color = '#EC7426';
                        break;
                    case 'Ended':
                        color = 'black';
                        break;
                    default:
                        color = 'black';
                        break;
                }
                return (
                    <span style={{ color: color }}>
                        {row.status}
                    </span>
                );
            },
            wrap: true
        },        
        {
            name: "Action",
            cell: row => {
                let actions = []
                if (row.status === "Active") {
                    actions = [
                        { label: 'Edit' },
                        { label: 'Deactivate' },
                    ]
                }
                if (row.status === "Deactivated") {
                    actions = [
                        { label: 'Edit' },
                        { label: 'Activate' },
                    ]
                }
                if (row.status === "Ended") {
                    actions = [
                        { label: 'Delete' },
                    ]
                }
                return (
                    <SellerActionDropdown options={actions} />
                )
            },
            wrap: true
        }
    ]

    const customStyles = {
        headCells: {
          style: {
            backgroundColor: "#f2f2f2",
            fontSize: "1rem",
            fontWeight: 600,
          },
        },
        cells: {
          style: {
            paddingBlock: "1rem",
          },
        },
      }

    return (
        <div className="p-3 bg-white">
            <FilterInTable componentName='Coupons All' />
            <div className="mt-3">
                <DatatableComponent data={data} columns={columns} type="gray" />
            </div>
        </div>
    )
}

export default Active